import React from 'react';
import { useTranslation } from 'react-i18next';
import SubmissionFilter from 'types/SubmissionFilter';
import {
  LumenDropdownMenu,
  LumenDropdownMenuItem,
  LumenButton,
} from '@photoshelter/socialie-components';

interface Props {
  value: SubmissionFilter['sort'];
  onChange: (value: SubmissionFilter['sort']) => void;
}

export default function SubmissionSort({ value, onChange }: Props) {
  const { t } = useTranslation();
  return (
    <LumenDropdownMenu
      side="bottom"
      renderTrigger={
        <div>
          <LumenButton color="transparent" leftIcon="sort-sort">
            {t(`ugcRequestShow.submissions.sort.${value}`)}
          </LumenButton>
        </div>
      }
    >
      <LumenDropdownMenuItem onSelect={() => onChange('newest')}>
        {t(`ugcRequestShow.submissions.sort.newest`)}
      </LumenDropdownMenuItem>

      <LumenDropdownMenuItem onSelect={() => onChange('oldest')}>
        {t(`ugcRequestShow.submissions.sort.oldest`)}
      </LumenDropdownMenuItem>
    </LumenDropdownMenu>
  );
}
